import { configOption, KahunConfigurationOptionType } from "../lib/annotations";

export class FontEndFeatureFlags {
  @configOption({
    displayName: "Debug mode",
    description: "For enabling debug features:  debug panel & debug buttons",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  debugSheet?: boolean = false;

  @configOption({
    displayName: "Demo Pane",
    description: "for enabling demo panel (desktop demo mode + graph icons)",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  demoPane?: boolean = false;

  @configOption({
    description:
      "Agent flag - shows check boxes next to items in the export summary (code itizik rote in feb 2021 - not sure what it does)",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  agentSummaryCheckboxes?: boolean = false;

  @configOption({
    description:
      "Agent flag - in export summary shows export group select (code itizik wrote in feb 2021 - no sure what it does)",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  agentSummaryFromSolver?: boolean = true;

  @configOption({})
  debugLevel?: number = 1;

  @configOption({
    displayName: "Report Facebook Pixel",
    description: "For facebook campaigns",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  reportFacebookPixel?: boolean = true;

  @configOption({
    displayName: "Report Linkedin Pixel",
    description: "For linkedin campaigns",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  reportLinkedPixel?: boolean = true;

  @configOption({
    description: "Option to jump to results page in the middle of chat",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  resultsButton?: boolean = false;

  @configOption({
    description:
      "Save case buttons so it can be opened in agent/explorer/reports",
    displayName: "Shoe save case buttons",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  saveCase?: boolean = false;

  @configOption({
    description: "show Less likely conditions?",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  possibleCauses?: boolean = true;

  @configOption({
    description: "Show “No” before the negated Summary",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  patientSummaryNoOnNegates?: boolean = false;

  @configOption({
    description: "Show summary assessment",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  patientSummaryAssessment?: boolean = true;

  @configOption({
    displayName: "Location diagrams",
    description: "show location diagrams",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  locationMaps?: boolean = true;

  @configOption({
    displayName: "More Info",
    description: "Shows clinical reasoning and description per disease",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showClinicalReasoningOnP1st?: boolean = false;

  @configOption({
    description:
      "whether to show our standard WELCOME_STANDALONE text or infomed's WELCOME_PARTNERS or any text /html that might be provided under WELCOME_PARTNERS translations key",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  standaloneWelcome?: boolean = false;

  @configOption({
    description: "Show what’s next options",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  whatsNext?: boolean = false;

  @configOption({
    displayName: "Computed LR As Strengths Indicator",
    description:
      'Consider computed LR  (sensitivity/1-computed specificity) as the strength indicator instead the previous default which is sensitivity/leak . The advantage of this method is that we eventually consider the diseases on the screen and show strength of a disease<->finding compared to other diseaes in the dd. That way "fatigue" will have a relatively low strength, while other, more specific findings, will have higher strengths',
    displayType: KahunConfigurationOptionType.Boolean,
  })
  UseLRsForStrengths?: boolean = false;

  @configOption({
    displayName: "Allow Numeric Questions",
    description: "Allow general numeric range questions",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  rangeQuestions?: boolean = true;

  @configOption({ displayType: KahunConfigurationOptionType.Boolean })
  whatsNextDoctorChat?: boolean = false;

  @configOption({
    description: 'Show chat with a doctor as one of "whats-next" items',
    displayType: KahunConfigurationOptionType.Boolean,
  })
  askDoctorAsButton?: boolean = true;

  @configOption({
    description:
      'Allow a "save assessment" button in whats next to download a pdf of the summary',
    displayType: KahunConfigurationOptionType.Boolean,
  })
  savePdfAssessment?: boolean = false;

  @configOption({
    description: "QR code represent URL to the patient Card",
    displayName: "Clinic QR Code",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  clinicQrCode: boolean = false;

  @configOption({
    displayName: "Kahuns insights link",
    description:
      "Show a link to the patient card at the end of the conversation",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showPatientCardLink?: boolean = false;

  @configOption({
    displayName: "Ignore cache",
    description:
      "sends no-cache in the request, revalidating the response. Allowing for moderators to see their latest changes",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  ignoreCache?: boolean = false;

  @configOption({
    displayName: "Show open in explorer",
    description:
      "Shows a button that can direct to the explorer for debugging ",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showOpenInExplorer?: boolean = false;

  @configOption({
    displayName: "Ask before background questions",
    description:
      "When set to true, background questions will appear as they are asked, without a client ui which asks `Do you have family history` `Do you have allergies` etc",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  askBeforePresentingBackgroundQuestions?: boolean = false;

  @configOption({
    displayName: "Show gender disclaimer",
    description:
      "When set to true, we allow a small question mark to appear next to gender selection explaining gender is based on biological sex",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showGenderDisclaimer?: boolean = false;

  @configOption({
    displayName: "Use 0-100 scale for percent units",
    description:
      "If set to false, sliders will show percent unites like all other unites based on maximum and minimum, otherwise percent units will make the slider 0-100",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  useTheWholeScaleForPercent?: boolean = true;

  @configOption({
    displayName: "Enable free text in chief complaint",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  ccAsFreeText?: boolean = false;

  @configOption({
    displayName: "Ask GPT free text chief complaint",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  ccAsGptFreeText?: boolean = false;

  @configOption({
    displayName: "Scroll only to last answer",
    description:
      "When turned on, the chat won't scroll to every question answered, but rather will scroll the last user answer so it will stick to top",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  scrollToLastAnswerOnly: boolean = false;

  @configOption({
    displayName: "Create visit record",
    description:
      "Create a visit record in Kahun after a patient answers a question",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  createVisitRecord: boolean = true;

  @configOption({
    displayName: "Show code at end of chat",
    description:
      "Show a patient a code at end of chat, this code allows the physyican to get his data",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showCodeAtEndOfChat: boolean = false;

  @configOption({
    displayName: "Inline location diagrams",
    description:
      "When turned on - this will make the location diagrams render inside the chat vs opening in an overlay above it",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  inlineDiagrams: boolean = false;

  @configOption({
    displayType: KahunConfigurationOptionType.Boolean,
    displayName: "Show feedback popup before results",
  })
  askForFeedbackPopup: boolean = false;

  @configOption({
    displayType: KahunConfigurationOptionType.Boolean,
    displayName: "Multiple Complaints (depracated)",
    isObsolete: true,
    description:
      "[Moved to conversation options]When turned on, instead of chief complaint we will show a dialog which will ask for any feature its duraion and will allow adding multiple symptoms at once",
  })
  multipleComplaints: boolean = false;

  @configOption({
    displayType: KahunConfigurationOptionType.Boolean,
    displayName: "Allow locale change",
    description:
      "When set to true a globos icon will appear in the app alowing users to change the language of the conversation mid-conversation",
  })
  localeChanger: boolean = false;

  @configOption({
    displayType: KahunConfigurationOptionType.Boolean,
    description:
      "When turned on - first time the undo and info icons appear they will have small tooltip to explain them",
  })
  showFirstTimeButtonsTooltip: boolean = false;

  @configOption({
    displayType: KahunConfigurationOptionType.String,
    description:
      "redirect after completion",
  })
  onCompletionUrl: string = "";

  @configOption({
    displayType: KahunConfigurationOptionType.String,
    description:
      "redirect after abandoned",
  })
  onAbandonUrl: string = "";
}
